import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './application.theme';
import { AboutMeNew, Intro, Layout, Projects, Stack, Terminal } from './components';
import { useState } from 'react';
import usePageBottom from './hooks/usePageBottom';

function App() {
  const [showTerminal, setTerminalVisibility] = useState(false)
  const handleReachedBottom = () => setTerminalVisibility(true);
  
  usePageBottom(handleReachedBottom)

  return (
    
      <ChakraProvider theme={theme}>
      <Layout >
        <Intro />
        <AboutMeNew />
        <Projects />
        {/* <Stack /> */}
      </Layout>
      {showTerminal ? <Terminal handleClose={() => setTerminalVisibility(false)}/> : null}
    </ChakraProvider>
  );
}

export default App;
